import React from 'react';
import PropTypes from 'prop-types';

const SvgPencil = ({ active, ...props }) => {
    const strokeColor = active ? '#ffffff' : '#343A72';
    const fillColor = active ? '#7AB3B3' : '#9A9DB6';
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="26" height="26" fill="none" viewBox="0 0 26 26" {...props}>
            <path
                stroke={strokeColor}
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="1.25"
                d="M7.77 24.528s16.758 0 12.744-3.87c-2.56-2.47 4.014-4.029 4.014-4.029"
            />
            <path
                stroke={strokeColor}
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="1.25"
                d="m1 24.528 2.233-8.115L15.062 3.234a.749.749 0 0 1 1.06-.055l4.462 4.03a.755.755 0 0 1 .056 1.063L8.81 21.452 1 24.528Z"
                clipRule="evenodd"
            />
            <path fill={fillColor} fillRule="evenodd" d="m1 24.528 1.12-4.072 2.8 2.528L1 24.528Z" clipRule="evenodd" />
            <path
                stroke={strokeColor}
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="1.25"
                d="m1 24.528 1.12-4.072 2.8 2.528L1 24.528Z"
                clipRule="evenodd"
            />
            <path
                stroke={strokeColor}
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="1.25"
                d="m3.233 16.413 5.578 5.038M17.068 1l5.577 5.038M6.035 18.944l12.362-13.71"
            />
        </svg>
    );
};

SvgPencil.propTypes = {
    active: PropTypes.bool,
};
SvgPencil.defaultProps = {
    active: false,
};

export default SvgPencil;
